import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralizeWithCount } from "@common/helpers/string";

interface Props {
    filters: Pick<FiltersTypes, "billIds">;
}

export const BillIdsFilterLabel: React.FC<Props> = ({ filters }) => {
    const billIds = filters.billIds;

    if (!billIds || billIds.length === 0) {
        return null;
    }

    return <>{pluralizeWithCount("bill", billIds.length)}</>;
};
